const SDK_VERSION = '7.64.0';

export { SDK_VERSION };
//# sourceMappingURL=version.js.map
